import React from 'react';
import { Calculator, PenLine, Ruler, History, ArrowRight } from 'lucide-react';
import { SectionHead } from './SectionHead';

const ITEMS = [
  { icon: Calculator, title: 'Indicators calculated in code', desc: 'RSI, EMAs, MACD, relative volume and ATR are computed deterministically from daily bars. Same data in, same score out.' },
  { icon: PenLine, title: 'AI writes the explanation', desc: 'The model turns the calculated numbers into plain language. Numbers it uses are checked against the inputs; failures fall back to a template.' },
  { icon: Ruler, title: 'Risk derived from ATR', desc: 'The risk level and the stop distance come from the 14-day average true range, so levels scale with how much the stock actually moves.' },
  { icon: History, title: 'Every outlook logged', desc: 'Each outlook is saved with a timestamp and its inputs, then graded against the closing price at the end of its timeframe.' },
];

export const NumbersBuilt = () => (
  <section className="mk-section" id="how-numbers-are-built" aria-labelledby="numbers-title">
    <div className="mk-container">
      <SectionHead id="numbers-title" eyebrow="Methodology" title="How our numbers are built" />
      <ul className="mk-num-strip" data-testid="numbers-strip">
        {ITEMS.map((it) => (
          <li key={it.title}>
            <it.icon size={20} aria-hidden="true" />
            <h3>{it.title}</h3>
            <p>{it.desc}</p>
          </li>
        ))}
      </ul>
      <a className="mk-link-arrow" href="/methodology" data-testid="numbers-methodology-link">Read the full methodology <ArrowRight size={16} aria-hidden="true" /></a>
    </div>
  </section>
);
